import {SubtaskUtil} from '@extensions/subtask-util'
import {DataObjectId, Hub, User} from 'yougile-model'
import {HTMLUtil} from 'yougile-util'
import {Sync} from '../../client/sync'
import {Task} from '../task'
import {TaskChatProxy, TaskChatProxyService} from './task-chat-proxy'
import {UserProxy} from './user-proxy'

export interface FullTaskChatProxy extends TaskChatProxy {
  readonly createdAt: number
  readonly parentProjectId: DataObjectId
  readonly parentProjectName: string
  readonly parentBoardId: DataObjectId
  readonly parentBoardName: string
  readonly parentColumnId: DataObjectId
  readonly parentColumnName: string
  readonly creatorId: DataObjectId
  readonly creatorImage: string
  readonly creatorInfo: string
  readonly creatorName: string
  readonly creatorShortName: string
  readonly creatorBackgroundColor: string
  hasItems: {
    chat: boolean
    description: boolean
    checklists: boolean
    links: boolean
  }
}

export const FullTaskChatProxy = {
  create: (user: User, hub: Hub): FullTaskChatProxy => {
    if (!user || !hub) {
      return undefined
    }
    const chat = TaskChatProxyService.create(user, hub)
    const creator = UserProxy.create(Task.creator(hub))
    const column = Task.parentColumn(hub)
    const board = Task.parentBoard(hub)
    const project = Task.parentProject(hub)

    return {
      ...chat,
      createdAt: hub.timestamp,
      parentProjectId: project?.id,
      parentProjectName: project?.title,
      parentBoardId: board?.id,
      parentBoardName: board?.title,
      parentColumnId: column?.id,
      parentColumnName: column?.title,
      creatorId: creator ? creator.userId : undefined,
      creatorImage: creator ? creator.userImage : undefined,
      creatorInfo: creator ? creator.userInfo : undefined,
      creatorName: creator ? creator.userName : undefined,
      creatorShortName: creator ? creator.userShortName : undefined,
      creatorBackgroundColor: creator ? creator.userBackgroundColor : undefined,
      hasItems: {
        chat: hub.chat.getMessagesCount() > 0,
        checklists:
          SubtaskUtil.hasSubtasks(hub) ||
          SubtaskUtil.getParentTaskIds(hub.id).length > 0 ||
          (hub.data?.checklists && hub.data.checklists.length > 0),
        description:
          hub.description &&
          HTMLUtil.extractText(hub.description).trim().length > 0,
        links: hub.listConnectedHubs().length > 0
      }
    }
  },

  createForCurrentUser: (hub: Hub): FullTaskChatProxy =>
    FullTaskChatProxy.create(Sync.getCurrentUser(), hub)
}
